import { TSTitleCard } from '@/components/shared/card/Card';
import { useSkills } from '@/services/tasks/useSkills';
import { FunctionComponent, useState } from 'react';
import { FiHome } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import adminStrings from '../admin.translations';
import AdminAddSkillModal from './AdminAddSkillModal';
import AdminSkillsTable from './AdminSkillsTable';

const AdminSkillsSection: FunctionComponent = () => {
  const [addSkillModalOpen, setAddSkillModalOpen] = useState(false);

  const navigate = useNavigate();

  const skills = useSkills();

  const onSkillsEdit = (id: string) => {
    navigate(`${id}`);
  };

  return (
    <>
      <TSTitleCard
        title={adminStrings.skillsSection.title}
        icon={FiHome}
        className="w-full"
        primaryAction={{
          label: adminStrings.skillsSection.table.addNew,
          onClick: () => {
            setAddSkillModalOpen(true);
          },
          icon: 'add'
        }}
      >
        <AdminSkillsTable skills={skills} onEdit={onSkillsEdit} />
      </TSTitleCard>
      <AdminAddSkillModal
        open={addSkillModalOpen}
        onClose={() => {
          setAddSkillModalOpen(false);
        }}
      />
    </>
  );
};

export default AdminSkillsSection;
